'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// Components

// Actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _components = require('../../components');

var _select = require('../../redux/modules/select');

var _booking = require('../../redux/modules/booking');

var _action = require('../../redux/modules/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Allocate = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    actions: state.action.actions,
    info: state.booking.data,
    orderNumber: state.booking.orderNumber
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    allocate: _booking.allocate, freeUpDriver: _booking.freeUpDriver, selectList: _select.selectList,
    setAction: _action.setAction
  }, dispatch);
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Allocate, _Component);

  function Allocate() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Allocate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Allocate.__proto__ || (0, _getPrototypeOf2.default)(Allocate)).call.apply(_ref, [this].concat(args))), _this), _this.__setOrderType = function () {
      var info = _this.props.info;
      var self = _this;
      if (info) {
        var orderType = info.error ? 'Not Available' : info.data.bookingType;
        self.type.value = orderType;
      }
    }, _this.allocateBooking = function () {
      var $props = _this.props;
      var info = $props.info ? $props.info : null;
      var bookingType = info.data.bookingType;
      $props.freeUpDriver().then(function () {
        return $props.allocate($props.orderNumber);
      }).then(function () {
        if (bookingType === 'Instant') {
          _this.loadActions().then(function () {
            var action = _this.props.actions.data.actions[0];
            $props.setAction(action.method, action.path).then(function () {
              $props.checkOrderStatus();
              $props.selectList('');
            });
          });
        } else {
          $props.checkOrderStatus();
          $props.alert('allocate');
        }
      });
    }, _this.loadActions = function () {
      var $props = _this.props;
      // graphQL query
      return $props.loadActions('{\n      actionList(id: "' + $props.orderNumber + '") {\n        data {\n          actions {\n            action, action_name, method, path, failure_reasons {\n              id\n            }\n          }\n        }\n        error {\n          code\n          message\n          errors\n        }\n      }\n    }');
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Allocate, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.__setOrderType();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var info = this.props.info;
      /* eslint one-var: [2, { "initialized": "never" }] */
      /* eslint-env es6 */

      var allocated = void 0;
      if (info) {
        var status = info.error ? 'Not Available' : info.data.status;
        var statusVal = status ? status.replace(/\s/g, '').toLowerCase() : null;
        // set allocated
        if (statusVal === 'findingdriver') {
          allocated = false;
        } else if (statusVal === 'notavailable') {
          allocated = true;
        } else {
          allocated = true;
        }
      } else {
        allocated = true;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('input', { type: 'text', ref: function ref(type) {
            return _this2.type = type;
          }, placeholder: 'Not Available', className: 'form-control input-plain', disabled: true }),
        _react2.default.createElement(_components.Button, { text: 'Allocate Booking', onclick: this.allocateBooking, disabled: allocated })
      );
    }
  }]);
  return Allocate;
}(_react.Component), _class2.propTypes = {
  // states
  actions: _propTypes2.default.object,
  info: _propTypes2.default.object,
  orderNumber: _propTypes2.default.string,
  // actions dispatch
  allocate: _propTypes2.default.func,
  freeUpDriver: _propTypes2.default.func,
  selectList: _propTypes2.default.func,
  setAction: _propTypes2.default.func,
  // actions custom props (set on calling the component)
  alert: _propTypes2.default.func,
  checkOrderStatus: _propTypes2.default.func,
  loadActions: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Allocate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Allocate/Allocate.js
// module id = 859
// module chunks = 0